<h2 class="popup-heading" mat-dialog-title>
  SHOW LINKING
</h2>

<mat-expansion-panel class="welcome-message" [expanded]="true">

  <div>
    <p>
      You can use show linking to allow the user to navigate
      between shows as if each show was a defined "zone".
      For each show, you can enter a label which will appear
      on the button allowing the user to navigate to a new
      zone or previous zone. Note that each show is controlled
      by either a static or synced show and has independent timing.
    </p>
  </div>

</mat-expansion-panel>

<div class="linking-shows-dialog">

  <!-- Loading Overlay -->
  <div class="dialog-loader" *ngIf="processing">

    <mat-spinner diameter="40">
    </mat-spinner>

  </div>

  <mat-dialog-content>

    <!-- Header -->
    <div class="linked-shows-header">
      <div class="header-drag"></div>
      <div class="header-show-name"> Show Name </div>
      <div class="header-show-code">Show Code</div>
      <div class="header-label">Label</div>

    </div>

    <!-- Linked Shows -->
    <div cdkDropList [cdkDropListData]="linkedShows" (cdkDropListDropped)="drop($event)" class="linked-shows-list">
      <div class="linked-show-row" *ngFor="let show of linkedShows" cdkDrag>

        <!-- Drag Handle -->
        <div class="drag-handle" cdkDragHandle>
          <mat-icon>
            drag_indicator
          </mat-icon>
        </div>

        <!-- Show Name -->
        <div class="show-name"> {{ show.show_name }} </div>

        <!-- Show Code -->
        <div class="show-code">{{ show.show_code }} </div>

        <!-- Label -->
        <div class="show-label">

          <div appearance="fill" class="label-field">

            <input matInput [(ngModel)]="show.label" class="label-input" placeholder="Enter label">
          </div>

        </div>
        <!-- Actions -->
        <div class="show-actions">
          <mat-icon *ngIf="show.is_main_show" matTooltip="Primary Show"  class="primary-star">star</mat-icon>

          <button *ngIf="!show.is_main_show" class="remove-button" (click)="removeLinkedShow(show)">
            <mat-icon>close</mat-icon>
          </button>

        </div>

      </div>

    </div>
    
  </mat-dialog-content>

  <div class="search-show">

      <mat-form-field class="table-search">
        <mat-label>Search shows...</mat-label>
        <input matInput placeholder="Enter show name or show code" #search (input)="searchShows(search.value)">
      </mat-form-field>

      <div class="search-results" *ngIf="searchResults.length > 0">

        <div class="search-result-row" *ngFor="let show of searchResults" (click)="addShowToLinkedShows(show)">

          <div class="search-result-name"> {{ show.show_name }} </div>

          <div class="search-result-code"> {{ show.show_code }} </div>

        </div>

      </div>

    </div>

  <mat-dialog-actions align="end">

    <button mat-button class="cancel-popup" mat-dialog-close [disabled]="processing">
      Close
    </button>

    <button mat-flat-button class="popup-save"
      [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}" [disabled]="processing"
      (click)="save()">
      <mat-spinner class="accent-spinner" *ngIf="saving" diameter="20"> </mat-spinner>
      <span>{{ saving ? 'Saving...' : 'Save' }}</span>
    </button>

  </mat-dialog-actions>

</div>